'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
// See http://jszen.blogspot.com/2007/03/how-to-build-simple-calendar-with.html for calendar logic.

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapLibInput = require('react-bootstrap/lib/Input');

var _reactBootstrapLibInput2 = _interopRequireDefault(_reactBootstrapLibInput);

var _reactBootstrapLibPopover = require('react-bootstrap/lib/Popover');

var _reactBootstrapLibPopover2 = _interopRequireDefault(_reactBootstrapLibPopover);

var _reactBootstrapLibButton = require('react-bootstrap/lib/Button');

var _reactBootstrapLibButton2 = _interopRequireDefault(_reactBootstrapLibButton);

var _reactBootstrapLibOverlayTrigger = require('react-bootstrap/lib/OverlayTrigger');

var _reactBootstrapLibOverlayTrigger2 = _interopRequireDefault(_reactBootstrapLibOverlayTrigger);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _components = {
	_$DatePickerHeader: {
		displayName: 'DatePickerHeader'
	},
	_$DatePickerCalendar: {
		displayName: 'DatePickerCalendar'
	},
	_$DatePicker: {
		displayName: 'DatePicker'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

_moment2['default'].locale('cs');

var makeInputValueString = function makeInputValueString(date) {
	var m = _moment2['default'](date);
	return m.format('D.M.YYYY');
};

var CalendarHeader = _wrapComponent('_$DatePickerHeader')(_react2['default'].createClass({
	displayName: "DatePickerHeader",
	propTypes: {
		displayDate: _react2['default'].PropTypes.object.isRequired,
		onChange: _react2['default'].PropTypes.func.isRequired,
		monthLabels: _react2['default'].PropTypes.array.isRequired,
		onDateClick: _react2['default'].PropTypes.func.isRequired,
		previousButtonElement: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]).isRequired,
		nextButtonElement: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]).isRequired
	},
	handleClickPrevious: function handleClickPrevious() {
		var newDisplayDate = new Date(this.props.displayDate);
		newDisplayDate.setMonth(newDisplayDate.getMonth() - 1);
		this.props.onChange(newDisplayDate);
	},
	handleClickNext: function handleClickNext() {
		var newDisplayDate = new Date(this.props.displayDate);
		newDisplayDate.setMonth(newDisplayDate.getMonth() + 1);
		this.props.onChange(newDisplayDate);
	},
	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: 'text-center' },
			_react2['default'].createElement(
				'div',
				{ className: 'text-muted pull-left', onClick: this.handleClickPrevious,
					style: { cursor: "pointer" } },
				this.props.previousButtonElement
			),
			_react2['default'].createElement(
				'span',
				{
					onClick: this.props.onDateClick },
				this.props.monthLabels[this.props.displayDate.getMonth()],
				' ',
				this.props.displayDate.getFullYear()
			),
			_react2['default'].createElement(
				'div',
				{ className: 'text-muted pull-right', onClick: this.handleClickNext,
					style: { cursor: "pointer" } },
				this.props.nextButtonElement
			)
		);
	}
}));

var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

var Calendar = _wrapComponent('_$DatePickerCalendar')(_react2['default'].createClass({
	displayName: "DatePickerCalendar",
	propTypes: {
		selectedDate: _react2['default'].PropTypes.object,
		displayDate: _react2['default'].PropTypes.object.isRequired,
		onChange: _react2['default'].PropTypes.func.isRequired,
		dayLabels: _react2['default'].PropTypes.array.isRequired,
		cellPadding: _react2['default'].PropTypes.string.isRequired,
		onUnmount: _react2['default'].PropTypes.func.isRequired
	},
	componentWillUnmount: function componentWillUnmount() {
		this.props.onUnmount();
	},
	handleClick: function handleClick(day) {
		var newSelectedDate = new Date(this.props.displayDate);
		newSelectedDate.setDate(day);
		this.props.onChange(newSelectedDate);
	},
	render: function render() {
		var _this = this;

		var currentDate = new Date();
		var currentDay = currentDate.getDate();
		var currentMonth = currentDate.getMonth();
		var currentYear = currentDate.getFullYear();
		var selectedDay = this.props.selectedDate ? this.props.selectedDate.getDate() : null;
		var selectedMonth = this.props.selectedDate ? this.props.selectedDate.getMonth() : null;
		var selectedYear = this.props.selectedDate ? this.props.selectedDate.getFullYear() : null;
		var year = this.props.displayDate.getFullYear();
		var month = this.props.displayDate.getMonth();
		var firstDay = new Date(year, month, 1);
		var startingDay = firstDay.getDay() - 1;
		var monthLength = daysInMonth[month];
		if (month == 1) {
			if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
				monthLength = 29;
			}
		}
		var weeks = [];
		var day = 1;
		for (var i = 0; i < 9; i++) {
			var week = [];
			for (var j = 0; j <= 6; j++) {
				if (day <= monthLength && (i > 0 || j >= startingDay)) {
					var selected = day === selectedDay && month == selectedMonth && year === selectedYear;
					var current = day === currentDay && month == currentMonth && year === currentYear;
					week.push(_react2['default'].createElement(
						'td',
						{ key: j, onClick: this.handleClick.bind(this, day),
							style: { cursor: "pointer", padding: this.props.cellPadding },
							className: selected ? "bg-primary" : current ? "today" : null },
						day
					));
					day++;
				} else {
					week.push(_react2['default'].createElement('td', { key: j }));
				}
			}
			weeks.push(_react2['default'].createElement(
				'tr',
				{ key: i },
				week
			));
			if (day > monthLength) {
				break;
			}
		}
		return _react2['default'].createElement(
			'table',
			{ className: 'text-center reactis-calendar' },
			_react2['default'].createElement(
				'thead',
				null,
				_react2['default'].createElement(
					'tr',
					{ className: 'day-labels' },
					this.props.dayLabels.map(function (label, index) {
						return _react2['default'].createElement(
							'td',
							{ key: index, style: { padding: _this.props.cellPadding } },
							_react2['default'].createElement(
								'small',
								null,
								label
							)
						);
					})
				)
			),
			_react2['default'].createElement(
				'tbody',
				null,
				weeks
			)
		);
	}
}));

var DatePickerClass = _wrapComponent('_$DatePicker')(_react2['default'].createClass({
	displayName: "DatePicker",
	propTypes: {
		value: _react2['default'].PropTypes.string,
		cellPadding: _react2['default'].PropTypes.string,
		dayLabels: _react2['default'].PropTypes.array,
		monthLabels: _react2['default'].PropTypes.array,
		onChange: _react2['default'].PropTypes.func,
		clearButtonElement: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]),
		previousButtonElement: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]),
		nextButtonElement: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.object]),
		placement: _react2['default'].PropTypes.string
	},
	getDefaultProps: function getDefaultProps() {
		return {
			cellPadding: "5px",
			dayLabels: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
			monthLabels: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
			placeholder: "",
			clearButtonElement: "×",
			previousButtonElement: "<",
			nextButtonElement: ">",
			placement: "bottom"
		};
	},
	getInitialState: function getInitialState() {
		var state = this.makeDateValues(this.props.value ? this.props.value : null);
		state.focused = false;
		return state;
	},
	makeDateValues: function makeDateValues(value) {

		var displayDate = undefined;
		var val = undefined;
		displayDate = new Date();
		displayDate.setHours(0);
		displayDate.setMinutes(0);
		displayDate.setSeconds(0);
		displayDate.setMilliseconds(0);

		var selectedDate = value ? new Date(value) : null;
		var isValid = value ? !isNaN(selectedDate.getTime()) : false;
		var isISO = isValid && (value == selectedDate.toISOString() || value == _moment2['default'](selectedDate).format("YYYY-MM-DD") || value == _moment2['default'](selectedDate).format("YYYY-MM-DD HH:mm:ss"));

		if (isValid) {
			if (isISO) {
				value = value ? makeInputValueString(selectedDate) : null;
			}
			displayDate = new Date(selectedDate);
			val = selectedDate ? selectedDate.toISOString() : null;
		} else {
			selectedDate = null;
		}

		return {
			value: val,
			displayDate: displayDate,
			selectedDate: selectedDate,
			inputValue: value
		};
	},
	clear: function clear() {
		this.setState(this.makeDateValues(null));
		if (this.props.onChange) {
			this.props.onChange(null);
		}
	},
	handleHide: function handleHide(e) {
		if (document.activeElement === this.refs.input.getInputDOMNode()) {
			return;
		}
		this.setState({
			focused: false
		});
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	},
	handleFocus: function handleFocus(e) {
		if (this.refs.overlay.state.isOverlayShown === true) {
			return;
		}
		this.setState({
			focused: true
		});
		if (this.props.onFocus) {
			this.props.onFocus(e);
		}
	},
	handleBlur: function handleBlur(e) {
		if (this.refs.overlay.state.isOverlayShown === true) {
			return;
		}
		this.setState({
			focused: false
		});
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	},
	handleHeaderDateClick: function handleHeaderDateClick(e) {},
	getValue: function getValue() {
		return this.state.selectedDate ? this.state.selectedDate.toISOString() : null;
	},
	handleInputChange: function handleInputChange(e) {
		var inputValue = this.refs.input.getValue();

		var dateReg = /^\d\d?[.]\d\d?[.]\d{4}$/;
		var validFormat = inputValue.match(dateReg);

		if (inputValue == '') {
			this.setState({
				inputValue: inputValue
			});
			if (this.props.onChange) {
				this.props.onChange(undefined);
			}
		} else {
			if (validFormat) {
				var selectedDate = _moment2['default'](inputValue, 'D.M.YYYY');
				if (selectedDate.isValid()) {
					this.setState({
						selectedDate: selectedDate.toDate(),
						displayDate: selectedDate.toDate(),
						value: selectedDate.toISOString()
					});
					if (this.props.onChange) {
						this.props.onChange(selectedDate.toISOString());
					}
				} else {
					this.setState({
						inputValue: inputValue
					});
				}
			} else {
				this.setState({
					inputValue: inputValue
				});
				if (this.props.onChange) {
					this.props.onChange(inputValue);
				}
			}
		}
	},
	onChangeMonth: function onChangeMonth(newDisplayDate) {
		this.setState({
			displayDate: newDisplayDate
		});
	},
	onChangeDate: function onChangeDate(newSelectedDate) {
		this.setState({
			inputValue: makeInputValueString(newSelectedDate),
			selectedDate: newSelectedDate,
			displayDate: newSelectedDate,
			value: newSelectedDate.toISOString()
		});
		this.refs.overlay.handleDelayedHide();
		if (this.props.onChange) {
			this.props.onChange(newSelectedDate.toISOString());
		}
	},
	componentWillReceiveProps: function componentWillReceiveProps(newProps) {
		var value = newProps.value ? newProps.value : null;
		if (this.getValue() !== value) {
			this.setState(this.makeDateValues(value));
		}
	},
	render: function render() {
		var calendarHeader = _react2['default'].createElement(CalendarHeader, {
			previousButtonElement: this.props.previousButtonElement,
			nextButtonElement: this.props.nextButtonElement,
			displayDate: this.state.displayDate,
			onDateClick: this.handleHeaderDateClick,
			onChange: this.onChangeMonth,
			monthLabels: this.props.monthLabels });
		var popOver = _react2['default'].createElement(
			_reactBootstrapLibPopover2['default'],
			{ id: 'calendar', placement: 'top', title: calendarHeader },
			_react2['default'].createElement(Calendar, { cellPadding: this.props.cellPadding, selectedDate: this.state.selectedDate,
				displayDate: this.state.displayDate, onChange: this.onChangeDate, dayLabels: this.props.dayLabels,
				onUnmount: this.handleHide })
		);

		return _react2['default'].createElement(
			'div',
			null,
			_react2['default'].createElement(
				_reactBootstrapLibOverlayTrigger2['default'],
				{ ref: 'overlay', trigger: 'click', rootClose: true, placement: this.props.placement,
					overlay: popOver, delayHide: 100 },
				_react2['default'].createElement(_reactBootstrapLibInput2['default'], _extends({}, this.props, {
					label: null,
					value: this.state.inputValue,
					ref: 'input',
					type: 'text',
					placeholder: this.props.placeholder,
					onFocus: this.handleFocus,
					onBlur: this.handleBlur,
					onChange: this.handleInputChange
				}))
			),
			_react2['default'].createElement('input', { type: 'hidden', id: this.props.id, name: this.props.name, value: this.state.value })
		);
	}
}));

exports['default'] = DatePickerClass;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-datepicker/src/DatePicker.js
 ** module id = 1018
 ** module chunks = 1
 **/